import React from 'react'
import BackButton from '../Components/BackButton'

export default function Subscribe() {
  return (
    <div>

      <div  style={{position:'absolute' , left:'10%'}} >
      <BackButton/>
      </div>
      <iframe style={{width:'100%' , height:'100vh'}}
     src='https://publisherads.click/?SMCampaign=7a2f9f4e-6f8f-4446-b728-2b0f5f7c467a&ClickID=YOUR_CLICK_ID&Pub_ID=YOUR_PUB_ID&Aff_ID=YOUR_AFF_ID&extra=YOUR_Dynamic_Parameter_IF_Needed&extra1=YOUR_Dynamic_Parameter_IF_Needed&utm_source=affiliate&utm_medium=cpc&utm_campaign={campaignid}&utm_content={adgroupid}&utm_term={keyword}&country=null&themeid=3&portal=AmazingVideos' />
    </div>
  )
}
